import React, { useEffect, useState } from "react";
import {
  EmailForm,
  LeftSide,
  PoweringSection,
  ScrollableRow,
  StyledDiscription,
  StyledDiv,
  StyledList,
  StyledSubTitle,
} from "./style";
import { GlobalContainer } from "../../../Global/layout";
import theme from "../../../../theme";
import { StyledHeadingh3 } from "../../../Global/headings";
import ShopifyFormModal from "../../PPCModals/ShopifyFormModal";
import GravityFormForm from "../../../GravityForm";
import { graphql, useStaticQuery } from "gatsby";
import { Col } from "antd";

const PoweringYourBusiness = ({ data }: any) => {
  const [emailValue, setEmailValue] = useState(false);
  const ShopifyEmailData = useStaticQuery(graphql`
    query HiringShopifyProcessSection {
      tsGfForm(databaseId: { eq: 12 }) {
        ...GravityFormFields
      }
      ts {
        gfSettings {
          recaptcha {
            publicKey
            type
          }
        }
      }
    }
  `);

  var formvalue: any;
  function getFormValues(value: object) {
    formvalue = value.input_2;
  }

  const [open, setOpen] = useState(false);

  const onSuccess = () => {
    setOpen(true);
    setEmailValue(formvalue);
  };

  useEffect(() => {
    if (open) {
      document.body.classList.add("fullscreen-model");
    } else {
      document.body.classList.remove("fullscreen-model");
    }
  }, [open]);

  return (
    <section className="dark">
      <PoweringSection color={theme.black}>
        <GlobalContainer>
          <ScrollableRow gutter={40}>
            <LeftSide xs={24} sm={24} md={24} lg={12} xl={12}>
              <StyledHeadingh3
                maxWidth="505px"
                color={theme.white}
                text={data?.faqSectionHeading}
              />
              <EmailForm data-aos="fade-up">
                <div className="hire_email_form">
                  <GravityFormForm
                    data={ShopifyEmailData}
                    successCallback={onSuccess}
                    getFormValues={getFormValues}
                  />
                </div>
              </EmailForm>
            </LeftSide>
            <Col data-aos="fade-up" xs={24} sm={24} md={24} lg={12} xl={12}>
              <StyledList>
                {data?.faqs?.map((items: any, index: number) => {
                  return (
                    <StyledDiv key={index}>
                      <StyledSubTitle>{items.faqHeading}</StyledSubTitle>
                      <StyledDiscription
                        dangerouslySetInnerHTML={{
                          __html: items.faqDescription,
                        }}
                      />
                    </StyledDiv>
                  );
                })}
              </StyledList>
            </Col>
          </ScrollableRow>
        </GlobalContainer>
      </PoweringSection>

      <ShopifyFormModal
        openShopifyFormModal={open}
        emailValue={emailValue}
        buttonText="Let’s Discuss Your Store"
      />
    </section>
  );
};

export default PoweringYourBusiness;
